import classnames from 'classnames2';
import React from 'react';

interface IComponentFactoryProps {
  name?: string;
  classes?: string;
}

/**
 * Factory function for creating functional stateless components used to
 * create static subcomponents with default class names.
 */

type IBaseComponentProps = { As?: string; className?: string };

export const componentFactory = <CP extends {}>({ name, classes }: IComponentFactoryProps) => {
  const Element: React.FC<CP & IBaseComponentProps> = props => {
    // TypeScript does not like performing `...rest` on generic object types so we cast below
    const { className, As = 'div' as any, ...rest } = props as IBaseComponentProps;

    return (
      <As className={classnames(classes, className)} {...rest}>
        {props.children}
      </As>
    );
  };

  if (name) {
    Element.displayName = name;
  }

  return Element;
};
